import './_cardDowload.scss';
import manual from '../../assets/img-card-relatorio.png';
import { useNavigate } from 'react-router-dom';

function CardDowload({title, anoId}){
    const navigate = useNavigate()

    return(
        <div className="card-dowload">
            <img src={manual} alt="img"/>
            <h4>{title}</h4>
            
            <span onClick={() => navigate(`/relatorio-conjunto?ano_id=${anoId}`)} className='btn-dowload' download={`relatorio-${anoId}`} type="application/pdf" >
                Download
            </span>
        </div>
    )
}

export default CardDowload;